import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CapturumInputNumberModule } from '@capturum/ui/input-number';
import { FieldType, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-number-format-type',
  imports: [FormlyModule, FormsModule, ReactiveFormsModule, CapturumInputNumberModule],
  templateUrl: './formly-number-format-type.component.html',
  styleUrl: './formly-number-format-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyNumberFormatTypeComponent extends FieldType {}
